export default "__VITE_ASSET__P_XmI3MF__"